module.exports = __webpack_public_path__ + "static/img/home-banner1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home-banner1.png
// module id = 532
// module chunks = 0